import homepage from 'js/homepage/';
import auth from 'js/auth';
import profile from 'js/profile';
import address from 'js/address';
import store from 'js/store';
import product from 'js/product';
import checkout from './checkout';
import contact from './contact';

const globals = window.GLOBALS;
const route = {
    homepage: homepage,
    auth: auth,
    profile,
    address,
    store,
    product,
    checkout,
    contact
};

if(typeof globals.page != 'undefined') {
    globals.page.constructor === Array ?
    globals.page.map((item) => {
        route && route[item] && route[item]()
        })
        :
        route && route[globals.page] && route[globals.page]();
  }